var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinancialHigh3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 47.208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.792,33.9a57.5,57.5,0,1,1-57.5-57.5,57.5,57.5,0,0,1,57.5,57.5",
    transform: "translate(47.208 -23.604)",
    fill: "#2d9f52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.233,28.219H16.514V9.742H11.978V28.219H10.193V7.943h8.04Zm10.309,0H26.757V.4H22.289V28.219H20.5V-1.4h8.04Zm10.243,0H37.066V-9.91H32.529V28.219H30.81V-11.639h7.975Zm10.309,0H47.306V-17.729H42.84V28.219H41.053V-19.529h8.04ZM10.4,30.71h38.49v1.8H10.4ZM6.344,16.317H-12.765V-11.639H25.383v8.1H23.663V-9.91H-10.978V14.517H6.344Zm0-4.43A9.535,9.535,0,0,1-3.141,2.339a9.537,9.537,0,0,1,9.485-9.55,9.535,9.535,0,0,1,9.483,9.55H14.042a7.7,7.7,0,1,0-15.4,0,7.713,7.713,0,0,0,7.7,7.751Zm.2-10.795c-.136-.068-.274-.137-.41-.208a.875.875,0,0,1-.619-.76.953.953,0,0,1,.413-.76A2.361,2.361,0,0,1,8.267-.5l.894-1.521a3.663,3.663,0,0,0-1.787-.623V-3.752H5.586v1.315a2.807,2.807,0,0,0-.619.345A2.6,2.6,0,0,0,3.8.263,2.673,2.673,0,0,0,5.38,2.476c.138.071.274.139.413.208,1.238.555,1.787.9,1.719,1.523a.932.932,0,0,1-.413.9A3.369,3.369,0,0,1,4.35,4.83L3.663,6.49a9.744,9.744,0,0,0,1.787.484V8.151H7.235V6.906a2.543,2.543,0,0,0,.758-.347A2.689,2.689,0,0,0,9.3,4.344c.136-1.936-1.651-2.768-2.751-3.252",
    transform: "translate(39.337 3.802)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialHigh3);
export default __webpack_public_path__ + "static/media/financial-high-3.47df2fe06248d73abdc2706ebfa43ed6.svg";
export { ForwardRef as ReactComponent };